import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { XLg } from 'react-bootstrap-icons'
import { useImperativeScroll } from '../utils/hooks'

const ModalStripeLink = ({ to, children }) => (
  <div className='position-relative w-100 py-2 px-2 bg-danger rounded text-white bg-website-color'>
    <a href={to} className='text-decoration-none text-white w-100 h-100 position-relative text-capitalize'> {children} </a>
  </div>
)

const Modal = ({ title, links, image = null, onHide, children }) => {
  useImperativeScroll(document.body, true)
  return (
    <>
      <div className='fade modal-backdrop show'></div>
      <div className="modal-project d-flex justify-content-center align-items-center">
        <div className='modal-project__content'>
          <Row className='ms-0 h-100'>
            <Col xs={3} md={2} className="modal-project__content-aside text-center pt-4 ps-0 pe-0">
              {image ?
                (<img src={image} alt={title} className="" width={50} height={50} />)
                : (<div className="text-xl font-weight-bold text-capitalize h1"> {title.substr(0, 2)} </div>)
              }
              {links && <div className="d-flex flex-column gap-2 mt-5">
                {links.map(link => {
                  return link.href && <ModalStripeLink key={`link-${link.title}`} to={link.href}>{link.title}</ModalStripeLink>
                })}
              </div>}
            </Col>
            <Col xs={9} md={10} className="modal-project__content-body py-4 ps-4 ps-xs-3 pe-4 overflow-hidden">
              <Row className='me-0'>
                <Col md={11} className="col-10">
                  <h2 className='fw-bold'>{title}</h2>
                </Col>
                <Col md={1} className="text-white text-end text-xl font-weight-bold col-1">
                  <button onClick={() => onHide()}>
                    <XLg size={20} color="white" />
                  </button>
                </Col>
              </Row>
              <div className='modal-project__content-body__desc font-weight-light py-4'>
                {children}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  )
}

export default Modal